/**
 * Checks two objects, and only objects,  for shallow equality.
 *
 * @param {Object} a - First object to compare.
 * @param {Object} b - Second object to compare.
 * @return {boolean} - True if the objects are shallow equal, false otherwise.
 */
export default function shallowEqual(a, b) {
  if (a === b) return true;
  if (a && !b) return false;
  if (!a && b) return false;
  if (!a && !b && a !== b) return false;

  const aKeys = Object.keys(a).sort();
  const bKeys = Object.keys(b).sort();

  if (aKeys.length !== bKeys.length) return false;

  for (let i = 0; i < aKeys.length; i += 1) {
    if (aKeys[i] !== bKeys[i]) return false;
    if (a[aKeys[i]] !== b[aKeys[i]]) return false;
  }

  return true;
}
